<app-roster-grade-statement-content [gradeStatement]="gradeStatement" [student]="student"></app-roster-grade-statement-content>

<!---
{{gradeStatement.gradeStatementText.displayText}}

<br>
<br>
<div *ngIf="showSelect">
    Please select a reason for issuing this grade {{gradeStatement.grade}}.
    <span *ngIf="['F','NC'].indexOf(student.gradeBanner)>=0">Extension Date: {{student.shrtckgIncompleteExtDateLastForFOrNC}}</span>
    <span *ngIf="['F','NC'].indexOf(student.gradeBanner) < 0">Extension Date: {{student.shrtckgIncompleteExtDate}}</span>

    <br>
    <br>
    <mat-radio-group [(ngModel)]="data.student.gradeResponse.gradeStatementOptionId" class="grade-statement-group">
        <mat-radio-button class="grade-statement-option-item"
                          *ngFor="let element of gradeStatementOptions"
                          [value]="element.id"><span class="format-display">{{element.statement}}</span>
        </mat-radio-button>

    </mat-radio-group>
</div>

<mat-checkbox [(ngModel)]="data.student.gradeResponse.agree" [checked]="data.student.gradeResponse.agree">
    I agree to the above statement.
</mat-checkbox>
-->

<app-button-list>
    <app-button (clickedEvent)="onCancelClick()" [toolTip]="'cancel'">Cancel </app-button>
    <app-button (clickedEvent)="onSubmitClick()" [toolTip]="'check_circle'" *ngIf="canSubmit()">Submit </app-button>
</app-button-list>


